import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { tomaRoles } from '@/mocks/jiuchou-ai';

export default function TomaAI() {
  return (
    <section className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            dark
            eyebrow="TOMA AI × 九畴云铺"
            title="AI 不是聊天机器人，而是商业网络的智能层"
            subtitle="对消费者、云社员、云店长、供应链与平台，TOMA AI 分别回答一个最核心的问题。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {tomaRoles.map((r, i) => (
            <Reveal key={r.role} delay={i * 70}>
              <div className="h-full p-6 rounded-lg bg-foreground-900 border border-foreground-700">
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-lg bg-accent-500/20 flex items-center justify-center">
                    <i className={`${r.icon} text-accent-300 text-xl`}></i>
                  </div>
                  <span className="font-medium text-background-100">{r.role}</span>
                </div>
                <div className="mt-4 text-lg font-heading font-bold text-background-50">
                  {r.question}
                </div>
                <div className="mt-2 text-primary-300 font-semibold text-lg">{r.answer}</div>
              </div>
            </Reveal>
          ))}

          {/* 补充卡 */}
          <Reveal delay={350}>
            <div className="h-full p-6 rounded-lg border border-secondary-500/40 bg-gradient-to-br from-secondary-500/10 to-foreground-900 flex flex-col justify-center">
              <i className="ri-brain-line text-secondary-400 text-3xl"></i>
              <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
                最终：AI 不是一个聊天机器人，而是整个商业网络的智能层。
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}